import { type HTMLAttributes, type ReactNode } from 'react';
import { cn } from '../lib/cn';

export type CardVariant = 'default' | 'interactive' | 'accent' | 'featured';

const VARIANT: Record<CardVariant, string> = {
  default: 'surface-card',
  interactive:
    'surface-card transition-all duration-normal ease-out hover:-translate-y-0.5 hover:shadow-md motion-reduce:transition-none motion-reduce:hover:translate-y-0',
  accent: 'surface-card border-l-4 border-l-yhelp-yellow dark:border-l-yhelp-yellow',
  featured: 'surface-card border-2 border-yhelp-yellow dark:border-yhelp-yellow',
};

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant;
  children: ReactNode;
}

export function Card({ variant = 'default', className, children, ...rest }: CardProps) {
  return (
    <div className={cn(VARIANT[variant], className)} {...rest}>
      {children}
    </div>
  );
}
